import type { ComponentType } from 'react'

import { useNavigate, useParams } from 'react-router-dom'

// This is a temporary solution for class components
export function withNavigation<T>(Component: ComponentType<T>) {
  return (props: T) => <Component {...props} navigate={useNavigate()} params={useParams()} />
}
